class VeluxoHeader extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = {signal: this.controller.signal};
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest('details[open]');
      if (!details) return;
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      details.querySelector('summary')?.focus();
    }, options);
    this.addEventListener('focusout', event => {
      // Only close when focus truly moves to another element outside the menu.
      // On phones (iOS Safari) taps leave relatedTarget empty, and closing here
      // hid the menu before the tap on a link could register.
      const next = event.relatedTarget;
      if (!next) return;
      this.querySelectorAll('details[open]').forEach(details => {
        if (!details.contains(next)) details.open = false;
      });
    }, options);
    this.addEventListener('click', event => {
      if (event.target.closest('a')) this.querySelectorAll('details[open]').forEach(details => details.open = false);
    }, options);
    document.addEventListener('cart:update', () => this.refreshCart(), options);
    window.addEventListener('pageshow', event => { if (event.persisted) this.refreshCart(); }, options);
    this.resizeObserver = new ResizeObserver(() => {
      const height = this.getBoundingClientRect().height + 'px';
      document.body.style.setProperty('--header-height', height);
      document.body.style.setProperty('--header-group-height', height);
    });
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.cartController?.abort();
    this.resizeObserver?.disconnect();
  }
  async refreshCart() {
    this.cartController?.abort();
    const controller = new AbortController();
    this.cartController = controller;
    try {
      const response = await fetch(this.dataset.cartUrl, {headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal});
      if (!response.ok) return;
      const cart = await response.json();
      if (controller.signal.aborted || !Number.isFinite(cart.item_count)) return;
      const count = this.querySelector('[data-vx-cart-count]');
      if (count) count.textContent = String(cart.item_count);
      const bubble = this.querySelector('.vxr-cart__count');
      if (bubble) bubble.hidden = cart.item_count === 0;
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Unable to refresh cart count.');
    }
  }
}
if (!customElements.get('veluxo-header')) customElements.define('veluxo-header', VeluxoHeader);
